import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-authentication-layout',
    templateUrl: './authentication-layout.html',
    imports: [RouterOutlet]
})
export class AuthenticationLayout {

}


